import React from 'react';

import Image from 'next/image';

import { Box, Card, CardContent, Typography } from '@mui/material';

import FingerprintIcon from '@mui/icons-material/Fingerprint';


const CarCardMobile = ({ car, setActiveStep, isSummary, setCar }) => {

  return (
    <Box width="100%" maxWidth={325} m="0 auto" mt={2}>
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          width: '100%',
          height: '100%',
        }}
      >
        <CardContent sx={{ pb: 2 }}>
          <Box display="flex" onClick={() => setActiveStep(0)}>
            <Box width={64} mr={2} display="flex" alignItems="center">
              <Image
                src="/img/placeholder-car.jpg"
                width={48}
                height={48}
                alt="Selected car"
              />
            </Box>
            <Box display="flex" flexDirection="column" justifyContent="center">
              <Typography>
                {car.make} {car.model}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {car.year}
              </Typography>
            </Box>
          </Box>
          {isSummary
            ? car.vin && (
                <Box
                  display="flex"
                  alignItems="center"
                  mt={3}
                  onClick={() => {
                    setCar({ ...car, vin: null });
                  }}
                >
                  <Box display="flex" alignItems="center" color="primary.light">
                    <FingerprintIcon />
                  </Box>
                  <Box ml={1} overflow="hidden" whiteSpace="nowrap">
                    <Typography style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {car.vin}
                    </Typography>
                  </Box>
                </Box>
              )
            : null}
        </CardContent>
      </Card>
    </Box>
  );
};

export default CarCardMobile;
